import { render, staticRenderFns } from "./relatedActivities.vue?vue&type=template&id=2bf17697&scoped=true&"
import script from "./relatedActivities.vue?vue&type=script&lang=js&"
export * from "./relatedActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf17697",
  null
  
)

export default component.exports